import UpdatePasswordGeneric from '../UpdatePasswordGeneric';

const UpdatePasswordLavoratore = () => {
    return (
        <UpdatePasswordGeneric
            verifyTokenRoute="/area-lavoratore/reset-password/verify-token"
            changePasswordRoute="/area-lavoratore/reset-password/change-password"
            verifyOtpRoute="/area-lavoratore/reset-password/verify-otp"
            loginRoute="/AreaLavoratore/login"
        />
    );
};

export default UpdatePasswordLavoratore;
